import { useState ,useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { Form, Input, Button, Select, } from "antd";

import MasterService from '../../service/_Master'
import Service from '../../service/Mgt-user'
import Actions from "../../redux/actions";
import FormControl from "../../component/form/FormControl";

import moment from "moment";
import "moment/locale/th";
moment.locale("th");

const { Option } = Select;

const FormExtend = styled(FormControl)`
    .form-button{
    padding-left: 0;
    padding-right: 0;
    button{
        width: 40%;
        color: white;
        background-color: #007BFF ;
    }

    button:hover{
        background-color: white;
        color : #007BFF;
        border-radius: 5px;
        transition: 0.3s;
    }
    }
    .form-item__btn-cancel{
        background-color: #1d1d1d !important;
    }
    .form-item__btn-cancel:hover{
        background-color: white !important;
        color : #1d1d1d;
        border-radius: 5px;
        transition: 0.3s;
        border-color: #1d1d1d;
    }
`;

export default function FormAddUser(props) {
    const dispatch = useDispatch()
    const [form] = Form.useForm();
    const ug = useSelector(state => state.acc.group_id)
    const [selOrg, setSelOrg] = useState([])
    const [selGroupId, setSelGroupId] = useState([])

    useEffect(() => {
        const init = async() =>{
            form.setFieldsValue({status: 1})
            if(props.userId){
                let user = await Service.getDetail(props.userId)
                console.log(user)
                if(user){
                    form.setFieldsValue({
                        firstName: user.first_name,
                        lastName: user.last_name,
                        tel: user.tel,
                        email: user.email,
                        orgId: user.org_id ? user.org_id : 0,
                        groupId: user.group_id ? user.group_id : null,
                        status: user.status,
                        isApprove: user.is_approve === null ? null : user.is_approve ? 1 : 0
                    })
                } 
            }

            if(ug == 4){
                let orgs = await MasterService.getOrg();
                if(orgs) setSelOrg(orgs)
                let ug = await MasterService.getUserGroup()
                if(ug) setSelGroupId(ug)
            }
        }

        init()
    }, [form, props.userId, ug]);

    const onFinish = async (values) => {
        if(props.userId){
            let result = await Service.update(props.userId, values)
            if(result){
                dispatch(Actions.mgtUser.updateUser(result))
                dispatch(Actions.popup.toggleVisible(false))
            }
        }else{
            let result = await Service.create(values)
            if(result){
                dispatch(Actions.mgtUser.addUser(result))
                dispatch(Actions.popup.toggleVisible(false))
            }
        }
    };

    const validateConfirmPassword = (rule, value, callback) =>
        value == form.getFieldValue("password")
            ? Promise.resolve()
            : Promise.reject(new Error("รหัสผ่านไม่ตรงกัน"));


    const formInput = () => {
        return (
            <>{ug == 4 ? (
                <>
                    <Form.Item
                        name={["orgId"]}
                        className="form-item__org-id"
                        label="ชื่อหน่วยงาน/องค์กร"
                        rules={[{ required: true }]}
                    >
                        <Select placeholder="กรุณาเลือก" allowClear>
                            {selOrg.map((item) => (<Option key={item.id} value={item.id}>{item.disp_name}</Option>))};
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name={["groupId"]}
                        className="form-item__group-id"
                        label="กลุ่มผู้ใช่งาน"
                        rules={[{ required: true }]}
                    >
                        <Select placeholder="กรุณาเลือก" allowClear>
                            {selGroupId.map((item) => (<Option key={item.id} value={item.id}>{item.disp_name}</Option>))};
                        </Select>
                    </Form.Item>
                </>
            ):(<></>)}
                <Form.Item
                    name={["email"]}
                    className="form-item__email"
                    label="อีเมล"
                    rules={[{ required: true, type: "email" }]}
                >
                    <Input disabled={props.userId ? true : false}/>
                </Form.Item>
                <Form.Item
                    name={["tel"]}
                    className="form-item__tel"
                    label="เบอร์โทรศัพท์"
                    rules={[
                        { required: true },
                    ]}
                >
                    <Input
                        onChange={(e) => {
                            let value = e.target.value.replace(/[^0-9]+/g, "");
                            form.setFieldsValue({ tel: value });
                        }}
                    />
                </Form.Item>
                <Form.Item
                    name={["firstName"]}
                    className="form-item__first-name"
                    label="ชื่อ"
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name={["lastName"]}
                    className="form-item__last-name"
                    label="นามสกุล"
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>
                {props.userId ? (<></>) : 
                (
                    <>
                    <Form.Item
                    name={["password"]}
                    className="form-item__password"
                    label="รหัสผ่าน"
                    rules={[{ required: true }]}
                >
                    <Input.Password />
                </Form.Item>
                <Form.Item
                    name={["confirmPassword"]}
                    className="form-item__confirm-password"
                    label="ยืนยันรหัสผ่าน"
                    dependencies={["password"]}
                    rules={[{ required: true }, { validator: validateConfirmPassword }]}
                >
                    <Input.Password />
                </Form.Item>
                    </>
                )}
                <Form.Item
                    name={["status"]}
                    className="form-item__status"
                    label="สถานะ"
                    rules={[{ required: true }]}
                >
                    <Select placeholder="กรุณาเลือก" allowClear>
                        <Option value={1}>ปกติ</Option>
                        <Option value={2}>แบน</Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    name={["isApprove"]}
                    className="form-item__is_approve"
                    label="สถานะการอนุมัติใช้งาน"
                >
                    <Select placeholder="กรุณาเลือก" allowClear>
                        <Option value={0}>ไม่อนุมัติ</Option>
                        <Option value={1}>อนุมัติ</Option>
                    </Select>
                </Form.Item>
                  <Form.Item className="form-button">
                  {props.userId ? 
                (props.permission.indexOf('update') >= 0 ? (<Button className="form-item__btn-submit btn-primary" htmlType="submit">อัพเดทบัญชี</Button>) : (<></>))
                : 
                (props.permission.indexOf('create') >= 0 ? (<Button className="form-item__btn-submit btn-primary" htmlType="submit">สร้างบัญชี</Button>) : (<></>))}
                    <Button className="form-item__btn-cancel" onClick={()=>{dispatch(Actions.popup.toggleVisible(false))}}>
                      ยกเลิก
                    </Button>
                </Form.Item>
            </>
        );
    };

    return (
        <FormExtend
            name={"form-crate-user"}
            column={2}
            inputs={formInput}
            onFinish={props.onFinish ? props.onFinish : onFinish}
            form={form}
            className={props.className ? props.className : "popup-form-mgt-user"}
        ></FormExtend>
    );
}
